<ngx-loading 
  [show]="loading" 
  [config]="loaderConfig"
  [template]="customLoadingTemplate">
</ngx-loading>

<ng-template #customLoadingTemplate>
  <div style="color: white; font-size: 16px; text-align: center; margin-top: 20px;">
    Loading...
  </div>
</ng-template>

<div class="lcd-dashboard-container">
  <header class="lcd-dashboard-header">
    <div class="lcd-welcome">
    <p class="dashboard-subtitle">Welcome back, <b>{{ currentUser?.username || 'Lecturer' }}</b></p>
    </div>
  </header>

  <section class="lcd-stats-row">
    <div class="lcd-stat-card" *ngFor="let stat of lcdStats">
      <div class="lcd-stat-value">{{ stat.value }}</div>
      <div class="lcd-stat-label">{{ stat.label }}</div>
    </div>
  </section>

  <section class="lcd-courses-section">
    <h2>Your Courses</h2>
    <ul>
      <li *ngFor="let course of lcdCourses">
        <span class="lcd-course-title">{{ course.name }}</span>
        <span class="lcd-students-count">{{ course.students }} students</span>
      </li>
    </ul>
  </section>

  
</div>

<!-- Debug Information -->
  <div class="diagnostics-panel">
    <h3>Debug Information:</h3>
    <p>Component loaded at: {{ currentTime | date:'medium' }}</p>
    <p>Data initialized: {{ recentActivities.length }} activities loaded</p>
  </div>

   <!-- Footer -->
    <div class="slogin-footer-container">
      <p class="slogin-copyright">AUCDT | UITS © 2025 All rights reserved</p>
    </div>
